import React, { Component } from 'react';
import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';

import './DialogModal.css';

interface Props{
    title?: any
    message: any,
    on_yes: Function,
    on_no?: Function,
    on_cancel?: Function,
    open?: boolean
}
interface State{
    open: boolean
}

export default class DialogModal extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            open: this.props.open || false
        };
    }
    componentDidUpdate(prevProps: Props){
        if(this.props.open !== prevProps.open && typeof this.props.open === 'boolean'){
            this.setState({ open: this.props.open })
        }
    }

    on_cancel = () =>{
        this.props.on_cancel?.();
        this.setState({ open: false });
    }
    on_yes = () =>{
        this.props.on_yes();
        this.setState({ open: false });
    }
    on_no = () =>{
        this.props.on_no?.();
        this.setState({ open: false });
    }

    render(){
        return (
            <Modal
                className="small dialog-modal"
                opened={this.state.open}
                close={()=>{ this.on_cancel() }}
            >
                <div className="modal-title">
                    { this.props.title || '' } <ModalClose close={()=>{ this.on_cancel() }}/>
                </div>
                <div className="modal-content">
                    
                    <div className="dialog-message">
                        { this.props.message }
                    </div>

                    <div className="dialog-buttons">
                        <div className="dialog-button yes" onClick={()=>{ this.on_yes() }}>
                            <i className=" fas fa-check"/> yes
                        </div>
                        <div className="dialog-button no" onClick={()=>{ this.on_no() }}>
                            <i className=" fas fa-times"/> no
                        </div>
                    </div>
                    <div className="no-data" onClick={this.on_cancel}>
                        <i className=" fas fa-ban"/> cancel
                    </div>
                </div>
            </Modal>
        );
    }
};

